import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-emp-salary-details',
  templateUrl: './emp-salary-details.component.html',
  styleUrls: ['./emp-salary-details.component.css']
})
export class EmpSalaryDetailsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/hrms/payroll/emp-salary-details/emp-salary-details.component.ts